module.exports = __webpack_public_path__ + "static/media/ElongedActive.15cad76b.svg";